package uk.co.nickthecoder.kyd

import uk.co.nickthecoder.glok.backend.backend
import uk.co.nickthecoder.glok.scene.Alignment
import uk.co.nickthecoder.glok.scene.Color
import uk.co.nickthecoder.glok.scene.Stage
import uk.co.nickthecoder.glok.scene.dsl.label
import uk.co.nickthecoder.glok.scene.dsl.scene
import uk.co.nickthecoder.glok.scene.dsl.style
import uk.co.nickthecoder.glok.util.log
import uk.co.nickthecoder.kojak.Json
import uk.co.nickthecoder.kyd.json.createGameFromJson
import uk.co.nickthecoder.kyd.nodes.Letterbox
import uk.co.nickthecoder.kyd.nodes.PlayActView

object Launcher {

    /**
     * @param initialActPath `null` to start on the normal act, or a resource path to an [ActResource] to
     *     jump to a different act at startup (for testing or cheating!).
     */
    fun play(stage: Stage, kydPath: String, initialActPath: String? = null) {

        with(stage) {
            title = "Loading..."
            scene(400, 400) {
                root = label("Loading Game Data...") {
                    style(".loading")
                    alignment = Alignment.CENTER_CENTER
                }
            }
            show()
            onClosed {
                log.info("Stage closed")
                PlayActView.instance.act?.stop()
            }
        }

        val folderPath = pathParent(kydPath) !!
        val filename = pathName(kydPath)
        val resources = backend.fileResources(folderPath)

        // Load .kyd file
        resources.loadText(filename) { gameText ->
            val jGame = Json.parse(gameText).asObject()
            val game = createGameFromJson(jGame, kydPath, resources, true)

            loadCode(game)

            val problems = game.resolveReferences()
            for (problem in problems) {
                log.warn(problem)
            }

            //val management = Management(game)
            Management.instance = game.management

            stage.title = game.title
            stage.resize(game.nominalSize.x, game.nominalSize.y)

            val actView = PlayActView(game).apply {
                PlayActView.instance = this
                scaleToNominalSize(game.nominalSize)
                actProperty.bindTo(game.management.actProperty)
            }

            val scene = stage.scene !!
            scene.backgroundColor = Color.BLACK
            scene.root = when (game.sizeConstraint) {

                SizeConstraint.LETTERBOX -> {
                    Letterbox(game.nominalSize, actView)
                }

                else -> actView
            }
            game.management.loadAct(initialActPath ?: game.initialActPath)
        }
    }

}

expect fun loadCode( game : Game )
